import { render, staticRenderFns } from "./DoctorAsissAcounting.vue?vue&type=template&id=64764948&scoped=true"
import script from "./DoctorAsissAcounting.vue?vue&type=script&lang=js"
export * from "./DoctorAsissAcounting.vue?vue&type=script&lang=js"
import style0 from "./DoctorAsissAcounting.vue?vue&type=style&index=0&id=64764948&prod&scoped=true&lang=css"
import style1 from "./DoctorAsissAcounting.vue?vue&type=style&index=1&id=64764948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64764948",
  null
  
)

export default component.exports